
const state = {
  showPwaDownloadPrompt: false
}

const mutations = {
  enablePwaDownloadPrompt (state) {
    state.showPwaDownloadPrompt = true
  },

  disablePwaDownloadPrompt (state) {
    state.showPwaDownloadPrompt = false
  }
}

const getters = {
  showPwaDownloadPrompt (state) {
    return state.showPwaDownloadPrompt
  }
}

const actions = {
  enablePwaDownloadPrompt (context) {
    context.commit('enablePwaDownloadPrompt')
  },

  disablePwaDownloadPrompt (context) {
    context.commit('disablePwaDownloadPrompt')
  }

}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/pwaDownloadPrompt.js